import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import {
  AnonymousConsentManagementBannerModule,
  ConsentManagementModule,
  GenericLinkModule,
  MediaModule,
  OutletModule,
  PageComponentModule,
} from '@spartacus/storefront';
import { GgCmsLinkComponent } from './gg-cms-link/gg-cms-link.component';
import { GgFooterNavNodeComponent } from './gg-footer-nav-node/gg-footer-nav-node.component';
import { GgFooterComponent } from './gg-footer.component';
import { GgTrustpilotComponent } from './gg-trustpilot/gg-trustpilot.component';

@NgModule({
  declarations: [
    GgFooterComponent,
    GgFooterNavNodeComponent,
    GgCmsLinkComponent,
    GgTrustpilotComponent,
  ],
  imports: [
    CommonModule,
    MediaModule,
    ConfigModule.withConfig({
      cmsComponents: {
        GGFooterComponent: {
          component: GgFooterComponent,
        },
        GGFooterNavNodeComponent: {
          component: GgFooterNavNodeComponent,
        },
        GGCMSLinkComponent: {
          component: GgCmsLinkComponent,
        },
      },
    } as CmsConfig),
    PageComponentModule,
    OutletModule,
    GenericLinkModule,
    I18nModule,
    ConsentManagementModule,
    AnonymousConsentManagementBannerModule,
  ],
})
export class GgFooterModule {}
